import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
/**Questo service è stato pensato per gestire le azioni da libreria a portale e viceversa quando non si
 * può sfruttare il data-flow parent-child
 */
export class ExternalActionService {
  private viewerManager$ = new Subject<boolean>();

  constructor() {}

  nextViewerManager(value: boolean) {
    this.viewerManager$.next(value);
  }

  getViewerManager() {
    return this.viewerManager$;
  }
}
